function _(t,e,s){class n{constructor(){this._dev=!1}set dev(t){this._dev=t}get dev(){return this._dev}}s.Settings=n,n.__name__="Settings",s.settings=new n}
//# sourceMappingURL=settings.min.js.map